export enum Market {
  all = 6,
  ox = 3,
  soy = 1,
  corn = 2,
  milk = 5,
  chicken = 7,
  swine = 9,
  alert = 10,
}